export function ProductSerialNumbersCtrl (
  $scope, 
  $translate, 
  $state, 
  workshopAPI, 
  messages, 
  crudGridAPI, 
  confirm
){
  $scope.crudGridAPI = crudGridAPI();
  $scope.crudGridAPI.data = $scope.serialNumbers;

  $scope.saveRow = function (serial_number, index) {
    var new_serial_number = {
      product_id : $scope.product.id,
      serial_number : serial_number.serial_number,
      id : serial_number.id || ''
    }
    var call = serial_number.id ? { url: '/product_serial_number', method: 'patch'}: {url: '/product_serial_numbers', method: 'post'};
    workshopAPI[call.method](call.url, new_serial_number, 'product_serial_number')
      .then(function (serial_numbers) {
        $scope.crudGridAPI.data = serial_number.id ? $scope.crudGridAPI.data : serial_numbers;
        $scope.crudGridAPI.toggleEditMode(serial_number, index);
        messages.show($translate.instant('SERIAL_NUMBER_SPACE.SERIAL_NUMBER_SAVED'), 'success');
        $state.reload();
      }, function (err) {
        messages.error(err);
      });
  };

  $scope.removeRow = function (number, index) {
    confirm.generic($translate.instant('SERIAL_NUMBER_SPACE.DELETE_CONFIRM')).then(function () {
       $scope.crudGridAPI.removeRow(number, index, '/product_serial_numbers/delete_from_product_list', 'id');
    }).then(function (numbers) {
      messages.show($translate.instant('SERIAL_NUMBER_SPACE.SERIAL_NUMBER_DELETED'), 'success');
      $scope.crudGridAPI.data.splice(index, 1) //= sources;
    });
  };
};